import * as React from 'react';

import { IconPropsType } from 'designSystem/types/icons';

interface ITriangleIconProps extends IconPropsType {}

const TriangleIcon = ({ ...props }: ITriangleIconProps) => (
  <svg
    width={18}
    height={9}
    viewBox="0 0 18 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9 8.5H16.7929L9 0.707107L1.20711 8.5H9Z"
      fill="#FDFDFD"
      stroke="#E0E2EB"
    />
    <path
      d="M2.58922 8.5H15.3969L9.00074 2.20133L2.58922 8.5Z"
      fill="#FDFDFD"
      stroke="#FDFDFD"
    />
  </svg>
);

export default TriangleIcon;
